import { CONFIG } from "../config";
import { Routes } from "../config/Routes";

/**
 * Función para devolver el nombre que tienen el submenus.
 * @param {String} nameOfOpenSubMenu El nombre que tienen los submenus, para controlar la apertura con un solo estado.
 * @param {Object} route 
 * @returns {String}
 */
export const nameOfSubmenu = (nameOfOpenSubMenu, route) => nameOfOpenSubMenu + route.path;

/**
 * Función para separar en palabras una cadena en formato "capitalize".
 * @param {String} input Cadena de entrada.
 * @returns {String}
 */
export const splitCapitalized = (input) => {
    if (!input || input === "") return "";
    const splitted = input.match(/[A-Z][a-z]+/g);
    return splitted ? splitted.join(" ") : input;
}

/**
 * Función para filtrar los datos de visualización
 * @param {Object} state El estado de los filtros.
 * @param {Array} data Los datos de visualización.
 * @returns {Array}
 */
export const filterData = (state, data) => {
    let newData = [...data];
    const filters = state.filters;
    const filterKeys = Object.keys(filters)
    filterKeys.map(key => {
        newData = newData.filter(f => f[key].toLowerCase().includes(filters[key].toLowerCase()))
    });
    return newData;
}

/**
 * Función para comprobar si un valor del localstorage que se ha borrado debe disparar el evento de desconectar
 * @param {String} eventKey La key del localstorage que se esta borrando en esos momentos.
 * @returns {Boolean}
 */
export const isDeletedStorageTriggerLogout = eventKey => {
    const storage = CONFIG.storage;
    const storageKeys = Object.keys(storage);
    let found = false;
    storageKeys.forEach(key => {
        if (eventKey.includes(storage[key]))
            found = true;
    });
    return found;
}

/**
 * Función de utilidad para deepmerge, permite mergear arrays.
 * @param {Array} destinationArray - El array destino.
 * @param {Array} sourceArray - El array fuente.
 * @param {Object} options - Opciones de mergeado.
 * @returns {Array} 
 */
export const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray

/**
 * Función para redirigir a una página después de impersonarse o desimpersonarse.
 * @param {Object} history - Objeto history.
 * @param {Function} setCurrentRoute - Setter de la ruta actual.
 */
export const redirectAfterImpersonationActions = (history, setCurrentRoute) => {
    history.push('/mis-datos');
    setCurrentRoute(Routes[0].submenu[0]);
}

/**
 * Función para obtener la url en base a una serie de condiciones
 * @param {Object} apiData - Datos del api del endpoint en concreto.
 * @param {String} [query=''] - Query params.
 * @param {Boolean} withoutCode - Variable booleana que nos indica que el endpoint no necesita codigo para ser enviado. Default a false.
 * @param {String} code - codOPerador o pkOPerador.
 * @returns {String}
 */
export const getApiUrl = (apiData, query = '', withoutCode, code) => {
    let url = `${apiData.endpoint}`;
    if (apiData.queryParam) {
        if (!withoutCode) url += `?${apiData.queryParam}=${code}`;
    } else {
        if(!withoutCode) url += `/${code}`;
    }
    if(apiData.path) url += `/${apiData.path}`;
    if(query && query !== '') url += `/${query}`
    return url;
}

/**
 * Función para parsear el mensaje de error que se envía al ErrorProvider.
 * @param {Object|String} e - Mensaje u objeto error
 */
export const parseErrorMessage = e => e instanceof Object ? e.message : e

/**
 * Función para extraer las filas de facturación
 * @param {Array} invoices 
 * @returns {Array}
 */
export const getBillData = invoices => invoices.filter(invoice => invoice.fileName[0] !== 'a' || invoice.fileName[0] !== 'A')

/**
 * Función para extraer las filas de abonos
 * @param {Array} invoices 
 * @returns {Array}
 */
export const getPaymentData = invoices => invoices.filter(invoice => invoice.fileName[0] === 'a' || invoice.fileName[0] === 'A')